import { cnpj, cpf } from 'cpf-cnpj-validator';
import { Dayjs } from 'dayjs';
import { UseControllerProps } from 'react-hook-form';
import { removeNonNumericChars } from '../../utils/formatters';

type FormRules = { [key: string]: UseControllerProps['rules'] };

export const formRules: FormRules = {
  fullNameRequired: { required: 'Nome completo é obrigatório' },
  responsibleNameRequired: { required: 'Nome do responsável é obrigatório' },
  emailRequired: {
    required: 'Email é obrigatório',
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: 'Email inválido',
    },
  },
  passwordRequired: {
    required: 'Senha é obrigatória',
    minLength: {
      value: 6,
      message: 'Senha tem que ter no mínimo 6 caracteres',
    },
  },
  phoneRequired: {
    required: 'Telefone é obrigatório',
    pattern: {
      value: /^\(\d{2,}\) \d{4,}-\d{4}$/,
      message: 'Telefone inválido',
    },
  },
  cpfRequired: {
    required: 'CPF é obrigatório',
    validate: (value: string) => {
      if (!cpf.isValid(value)) return 'CPF inválido';
      return true;
    },
  },
  cnpjRequired: {
    required: 'CNPJ é obrigatório',
    validate: (value: string) => {
      if (!cnpj.isValid(value)) return 'CNPJ inválido';
      return true;
    },
  },
  bankRequired: {
    required: 'Número do banco é obrigatório',
  },
  accountRequired: {
    required: 'Número da conta é obrigatório',
  },
  agencyRequired: {
    required: 'Número da agência é obrigatório',
  },
  postalCodeRequired: {
    required: 'CEP é obrigatório',
    validate: (value: string) => {
      const cleanedValue = removeNonNumericChars(value);
      return cleanedValue.length !== 8 ? 'CEP inválido' : true;
    },
  },
  addressNumberRequired: {
    required: 'Número obrigatório',
  },
  hourPriceRequired: {
    required: 'Valor da hora é obrigatório',
    minLength: {
      value: 4,
      message: 'Valor da hora a ser cobrada inválido',
    },
  },
  subjectsRequired: {
    required: 'É necessário selecionar pelo menos uma matéria',
  },

  elementaryRequired: {
    required: 'Valor da aula do ensino fundamental/médio é obrigatório',
    minLength: {
      value: 4,
      message: 'Valor da aula inválido',
    },
  },
  universityRequired: {
    required: 'Valor da aula do ensino superior é obrigatório',
    minLength: {
      value: 4,
      message: 'Valor da aula inválido',
    },
  },
  birthdateRequired: {
    required: 'Data de aniversário é obrigatório',
    validate: (value: Dayjs) => {
      return isNaN(value.toDate().getTime()) ? 'Data inválida' : true;
    },
  },
  dateRequired: {
    required: 'Data da aula é obrigatória',
    validate: (value: Dayjs) => {
      return isNaN(value.toDate().getTime()) ? 'Data inválida' : true;
    },
  },
  timeRequired: {
    required: 'Hora é obrigatório',
    validate: (value: Dayjs) => {
      return isNaN(value.toDate().getTime()) ? 'Hora inválida' : true;
    },
  },
  reportRequired: {
    required: 'Relatório é obrigatório',
  },
  taughtContentRequired: {
    required: 'Conteúdo da aula é obrigatório',
  },
  subjectNameRequired: {
    required: 'Nome da materia é obrigatória',
  },
  classLocationRequired: {
    required: 'Local da aula é obrigatório',
  },
  reviewRequestRequired: {
    validate: (value: string) => {
      return /^\s*$/.test(value)
        ? 'Em branco: escreva uma solicitação ou cancele'
        : true;
    },
  },
};
